import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import searchIcon from "../../assets/icons/search.svg";

const SearchBar = ({
  searchQuery,
  setSearchQuery,
  setRefreshTrigger,
  placeholder = "Search...",
  icon = searchIcon,
  containerClass = "",
  inputClass = "",
  buttonClass = "",
  iconClass = "w-5 h-5",
  closeIconClass = "w-4 h-4",
  onKeyPress,
}) => {
  return (
    <div className={`flex items-center relative ${containerClass}`}>
      <img src={icon} alt="search" className={iconClass} />
      <input
        type="text"
        placeholder={placeholder}
        className={inputClass}
        value={searchQuery}
        onChange={(e) => {
          const value = e.target.value;
          setSearchQuery(value);
          if (value.trim() === "") {
            setRefreshTrigger((prev) => prev + 1);
          }
        }}
        onKeyDown={onKeyPress}
      />
      {searchQuery && (
        <button
          onClick={() => {
            setSearchQuery("");
            setRefreshTrigger((prev) => prev + 1);
          }}
          className={buttonClass}
        >
          <AiOutlineClose className={closeIconClass} />
        </button>
      )}
    </div>
  );
};

export default SearchBar;
